// Small affordance tooltip for anything clickable - the exact Vital City New
// pattern (user 2026-08-20/21: whatever is clickable must say so on hover,
// and clickability stays even while the drill-down data is still being
// provisioned - the stores live elsewhere).
import React from "react";
import { Tooltip } from "antd";

const ClickTip = ({ on = true, title = "Click to view the answers", children }) =>
  on ? (
    <Tooltip title={title} mouseEnterDelay={0.5} placement="top">
      {children}
    </Tooltip>
  ) : (
    children
  );

export default ClickTip;
